import { o } from "../nexus-client-4D0Jw00_.js";
const e = o.benefit;
export {
  e as benefit
};
/*                             */
